'use client'

import Script from 'next/script'
import { useTermlyConsent } from './useTermlyConsent'

interface ConsentBasedMicrosoftUETProps {
  tagId: string
  debug?: boolean
}

export function ConsentBasedMicrosoftUET({
  tagId,
  debug = false
}: ConsentBasedMicrosoftUETProps) {
  const hasConsent = useTermlyConsent(debug)

  if (!hasConsent) {
    return null
  }

  const safeTagId = JSON.stringify(tagId)

  return (
    <Script
      id="microsoft-uet-script"
      data-testid="microsoft-uet-script"
      data-category="advertising"
      strategy="afterInteractive"
    >
      {`
        (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:${safeTagId},enableAutoSpaTracking:true};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");
      `}
    </Script>
  )
}

export default ConsentBasedMicrosoftUET
